/**
 * Sysadmin Models — layout (Wave 3 / M6c).
 *
 * Pure layout file with <Outlet /> so child routes mount correctly:
 *   - models/index.tsx        — catalog browser (criterion 1)
 *   - models.new.tsx          — create-model wizard (criterion 2)
 *   - models.functions.tsx    — wrapper function library (criterion 3)
 *   - models.assignments.tsx  — assignment matrix (criterion 4)
 *   - models.trust-toggles.tsx — trust toggle authoring (criterion 5)
 *   - models.runtime.tsx      — load/unload + hardware monitor (6+7)
 *
 * Mirrors the tenants.tsx pattern from W1a-17.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router';
import { CatalogEntityTabBar } from '@/components/catalog-entity-tabs';

export const Route = createFileRoute('/sysadmin/models')({
  component: ModelsLayout,
});

function ModelsLayout() {
  // Render the shared Catalog entity-tab bar above the Models content so the
  // entity nav PERSISTS when the operator is in the Models section (which is
  // physically the legacy /sysadmin/models tree, not under catalog.tsx). The
  // Models section's own sub-tabs (Catalog/Functions/Trust Toggles/Assignments/
  // Runtime) render inside the child pages, below this bar.
  return (
    <div className="flex flex-col h-full">
      <CatalogEntityTabBar />
      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
